//Material Ui
import { TableCell, TableRow } from "@mui/material";
import React from "react";
import { Currency } from "../../../../helpers/currencyConvert";
import { formatJavaCompletossx } from "../../../../config/strings";

const cellStyles = {
  fontFamily: "Roboto, sans-serif",
  fontSize: "0.9rem",
  fontWeight: "400",
  borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
  cursor: "pointer",
};

const amountCellStyles = {
  ...cellStyles,
  textAlign: "right",
};

const dateCellStyles = {
  ...cellStyles,
  textAlign: "center",
};

export const tablaComprobantes = (data, t, dates, i) => {
  return (
    <TableRow key={i}>
      <TableCell className="amount-cell" sx={{ ...amountCellStyles }}>
        {data?.agencyNumber || "-"}
      </TableCell>
      <TableCell className="date-cell" sx={{ ...dateCellStyles }}>
        {dates.formatLocalDate(data?.operationDate, formatJavaCompletossx) ||
          "-"}
      </TableCell>
      <TableCell className="amount-cell" sx={{ ...amountCellStyles }}>
        {data?.raffleNumber || data?.serie || "-"}
      </TableCell>
      <TableCell className="amount-cell" sx={{ ...amountCellStyles }}>
        {data?.nroNote}
      </TableCell>
      <TableCell className="date-cell" sx={{ ...cellStyles }}>
        {data?.type
          ? data?.type === "Salida"
            ? t("delivery")
            : t("return")
          : "-"}
      </TableCell>
      <TableCell className="amount-cell" sx={{ ...amountCellStyles }}>
        {data?.nroCouponFrom || "-"}
      </TableCell>
      <TableCell className="amount-cell" sx={{ ...amountCellStyles }}>
        {data?.nroCouponTo || "-"}
      </TableCell>
      <TableCell className="amount-cell" sx={{ ...amountCellStyles }}>
        {data?.couponQty || "-"}
      </TableCell>
      <TableCell className="amount-cell" sx={{ ...amountCellStyles }}>
        {<Currency value={data?.price * data?.couponQty} /> || "-"}
      </TableCell>
    </TableRow>
  );
};
